const collectStyles = (): string =>
  Array.from(document.querySelectorAll('style'))
    .map((s) => {
      if (s.sheet?.cssRules?.length) {
        const rules = Array.from(s.sheet.cssRules)
          .map((r) => r.cssText)
          .join('');
        return `<style>${rules}</style>`;
      }
      return s.outerHTML;
    })
    .join('');

const fetchExternalStyles = (): Promise<string[]> =>
  Promise.all(
    Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(
      async (link) => {
        try {
          const res = await fetch((link as HTMLLinkElement).href);
          const css = await res.text();
          return `<style>${css}</style>`;
        } catch {
          return '';
        }
      },
    ),
  );

export const exportDirectiveToPdf = async (
  referenceId: string,
  projectName: string,
): Promise<void> => {
  const el = document.querySelector('[data-testid="project-directive-view"]');
  if (!el) return;

  const inlineStyles = collectStyles();
  const fetchedStyles = (await fetchExternalStyles()).join('');
  const title = `Project directive - ${referenceId} - ${projectName}`;

  const win = window.open('', '_blank');
  if (!win) return;

  win.document.write(
    `<html><head><title>${title}</title>
    ${inlineStyles}${fetchedStyles}
    <style>[data-testid="directive-export-pdf-btn"]{display:none}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}body{opacity:0}@media print{body{opacity:1}}</style>
    </head><body>${el.outerHTML}</body></html>`,
  );
  win.document.close();
  win.onafterprint = () => win.close();
  win.focus();
  win.print();
};
